import { NavLink } from 'react-router-dom';
import { AuthPageShell } from './AuthPageShell.tsx';
import styles from './SideRailShell.module.css';

export interface SideRailItem {
  to:    string;
  label: string;
  icon:  React.ReactNode;
}

interface SideRailShellProps {
  /** aria-label of the rail. */
  label:        string;
  items:        SideRailItem[];
  /** Pinned to the bottom of the rail. */
  bottomItems?: SideRailItem[];
  children:     React.ReactNode;
}

function sideRailClass({ isActive }: { isActive: boolean }) {
  return `${styles.sideRailLink}${isActive ? ` ${styles.sideRailLinkActive}` : ''}`;
}

function RailLink({ item }: { item: SideRailItem }) {
  return <NavLink to={item.to} className={sideRailClass} title={item.label} aria-label={item.label}>{item.icon}</NavLink>;
}

/** Full-height section layout: the icon side rail on the left, the section's page on the right. */
export function SideRailShell({ label, items, bottomItems, children }: SideRailShellProps) {
  return (
    <AuthPageShell maxWidth="none" padTop="0" padX="0" flexMain hideFooter>
      <div className={styles.shell}>
        <aside className={styles.sideRail} aria-label={label}>
          <nav className={styles.sideRailNav}>
            {items.map((item) => <RailLink key={item.to} item={item} />)}
            {bottomItems && (
              <>
                <div className={styles.sideRailSpacer} />
                {bottomItems.map((item) => <RailLink key={item.to} item={item} />)}
              </>
            )}
          </nav>
        </aside>
        <div className={styles.content}>
          {children}
        </div>
      </div>
    </AuthPageShell>
  );
}
